module.exports = __webpack_public_path__ + "static/digitalmarketing-b66319eb36ff46654ab40c0466f19f79.svg";